import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import "rxjs/add/operator/take";
import { AuthenticationService } from "@core/store/auth/authentication.service";
import { Store } from "@ngrx/store";
import * as fromRoot from "@core/store/reducers";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";

@Injectable()
export class AuthenticatedGuard implements CanActivate, CanActivateChild {
  constructor(
    // private router: Router,
    private store: Store<fromRoot.AppState>,
    private authService: AuthenticationService,
    private router: Router,
  ) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.authService.isAuthenticated().pipe(
      tap((isAuthenticated: boolean) => {
        if (!isAuthenticated) {
          console.log("not authenticated!, go to login");
          this.authService.setInterruptedUrl(state.url);

          this.navigate("/login");
        }
      }),
    );
  }

  public canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.canActivate(route, state);
  }

  /**
   * Navigate away from the app / path
   */
  private navigate(url: string): void {
    if (url.startsWith("http")) {
      window.location.href = url;
    } else {
      this.router.navigateByUrl(url);
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/guards/authenticated.guard.ts